import React from "react";
import introduceImg from "../../assets/img/brochure/introduce.png";
import Reveal from "../common/Reveal";
import NetworkBackground from "../common/NetworkBackground";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={40} />
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-24">
        {/* 텍스트 영역 */}
        <Reveal>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
            ABOUT MTST
          </span>
          <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
            스마트 제조 생태계의
            <br />
            글로벌 리더
          </h1>
          <p className="mt-6 max-w-xl break-keep text-lg leading-relaxed text-gray-600">
            엠티에스티는 다양한 산업 분야에서 축적한 경험과 IT 솔루션
            기술력을 바탕으로 제조업에 최적화된 스마트공장 및 MES 솔루션을
            제공합니다. AI를 활용해 고객의 생산성과 운영 효율성을 극대화하는
            데이터 기반 제조 환경을 함께 만들어갑니다.
          </p>
        </Reveal>

        {/* 이미지 영역 */}
        <Reveal direction="left" delay={100} className="flex justify-center">
          <div className="aspect-square w-full max-w-sm overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-primary-100 transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl">
            <img
              src={introduceImg}
              alt="MTST 스마트 제조 플랫폼 구조"
              className="h-full w-full object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
